<template>
  <b-overlay :show="isFetchingCmsSite">
    <b-row>
      <b-col class="text-right mb-2">
        <b-button
          variant="success"
          @click="$bvModal.show('cms-create-game-banner')"
          >New Game Banner</b-button
        >
      </b-col>
    </b-row>
    <b-table :fields="fields" :items="cmsGameBanners" responsive>
      <template #cell(#)="data">
        <div>
          {{ data.index + 1 }}
        </div>
      </template>
      <template #cell(imageSrc)="data">
        <b-img :src="data.value" width="auto" height="150px"></b-img>
      </template>
      <template #cell(position)="data">
        <div>
          <b-badge variant="info">{{ data.value }}</b-badge>
        </div>
      </template>
      <template #cell(hasLink)="data">
        <div>
          <b-badge v-if="data.value" variant="success">Yes</b-badge>
          <b-badge v-else variant="danger">No</b-badge>
        </div>
      </template>
      <template #cell(isExternalLink)="data">
        <div>
          <b-badge v-if="data.value" variant="success">Yes</b-badge>
          <b-badge v-else variant="danger">No</b-badge>
        </div>
      </template>
      <template #cell(internalLinkTo)="data">
        <div>
          {{ data.value || '-' }}
        </div>
      </template>
      <template #cell(externalLinkTo)="data">
        <div>
          {{ data.value || '-' }}
        </div>
      </template>
      <template #cell(id)="data">
        <div>
          <b-button
            size="sm"
            variant="danger"
            @click="onRemoveBanner(data.value)"
            >Remove</b-button
          >
        </div>
      </template>
    </b-table>
    <CreateCmsGameBanner />
  </b-overlay>
</template>

<script>
import { mapActions, mapGetters, mapState } from 'vuex'

export default {
  components: {
    CreateCmsGameBanner: () => import('./create-game-banner.vue'),
  },
  data() {
    return {
      fields: [
        '#',
        {
          key: 'imageSrc',
          label: 'Image',
        },
        {
          key: 'position',
          label: 'Position',
        },
        {
          key: 'hasLink',
          label: 'Has link',
        },
        {
          key: 'isExternalLink',
          label: 'External link',
        },
        {
          key: 'internalLinkTo',
          label: 'Internal Link',
        },
        {
          key: 'externalLinkTo',
          label: 'External Link',
        },
        {
          key: 'id',
          label: 'Actions',
          class: 'text-right',
        },
      ],
    }
  },
  computed: {
    ...mapGetters(['cmsGameBanners', 'siteId']),
    ...mapState({
      isFetchingCmsSite: (state) => state.cms.isFetchingCmsSite,
    }),
  },
  methods: {
    ...mapActions(['removeCmsGameBanner']),
    onRemoveBanner(gameBannerId) {
      this.$bvModal.msgBoxConfirm('Are you sure?').then((value) => {
        if (value) {
          this.removeCmsGameBanner({ siteId: this.siteId, gameBannerId })
        }
      })
    },
  },
}
</script>
